import { ReactElement } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useStoreyImages } from '@editor/hooks'
import { useModelStore } from '@editor/stores'
import { useCameraStore } from '@modugen/ui-toolkit'
import FloorplanImage from '../FloorplanImage'
import SceneErrorIndicatorFallback from '../SceneErrorIndicatorFallback'

const STOREY_IMAGE_Z_OFFSET = 0.05

const StoreyImages = (): ReactElement | null => {
  const isOrthographic = useCameraStore(state => state.isOrthographic)
  const { storeyImages } = useStoreyImages()
  const availableStoreys = useModelStore(state => state.availableStoreys)
  const storeyBoundaries = useModelStore(state => state.model.storey_boundaries)

  if (isOrthographic) return null

  return (
    <>
      {Array.from(availableStoreys).map(storey => {
        const image = storeyImages[storey]
        if (!image?.isVisible3D) return null

        const boundary = storeyBoundaries[storey]
        const z = boundary ? boundary[0] - STOREY_IMAGE_Z_OFFSET : -STOREY_IMAGE_Z_OFFSET

        return (
          <ErrorBoundary
            key={`storey-image-3d-${storey}`}
            fallbackRender={({ error }) => (
              <SceneErrorIndicatorFallback
                error={error}
                context={'Fehler beim Laden der Hintergrundfolie. '}
              />
            )}
          >
            <FloorplanImage
              scale={image.scale}
              offsetX={image.offsetX}
              offsetY={image.offsetY}
              rotation={image.rotation}
              foregroundTransparency={image.transparencyConfig['3D'].foreground}
              backgroundTransparency={image.transparencyConfig['3D'].background}
              paperFormat={image.paperFormat}
              paperWidthCm={image.paperWidthCm}
              url={image.url}
              z={z}
            />
          </ErrorBoundary>
        )
      })}
    </>
  )
}

export default StoreyImages
